import { IconFixDelivery16 } from '@stitch-fix/mode-react';
export interface AdultIncentiveModalContent {
  heading: string;
  body: string;
  subText: string;
  cta: string;
  href: string;
}
export interface AdultIncentiveRouteOverride {
  bannerCopy: {
    id: string;
    text: string;
    Icon: typeof IconFixDelivery16;
  };
  modalContent: AdultIncentiveModalContent;
}
const menFixRouteOverride: AdultIncentiveRouteOverride = {
  bannerCopy: {
    id: 'AdultsFirstFixDiscountBanner-MenFix-30dollar',
    text: 'Limited time: $30 off your Fix + free styling',
    Icon: IconFixDelivery16
  },
  modalContent: {
    heading: 'Limited time: $30 off your Fix + free styling',
    body: 'Take your style quiz or log in to your existing account to schedule your Fix. Offer expires 7 days after signing up for new clients. Offer available to select existing clients. Log in to your account to determine eligibility.',
    subText: '',
    cta: 'Get $30 off your Fix',
    href: '/signup'
  }
};
const adultIncentiveRouteOverrides: Record<string, AdultIncentiveRouteOverride> = {
  '/men-fix': menFixRouteOverride,
  '/d/men-fix': menFixRouteOverride
};
export const getAdultIncentiveRouteOverride = (normalizedPath: string) => adultIncentiveRouteOverrides[normalizedPath];